import { create } from 'zustand';

import { ApproveTransfers } from '@/entities/TeamLeagueInfo';

interface TeamLeagueLabels {
	tieBreakerMatchTitle: string;
	tieBreakerMatchPluralTitle: string;
	districtSingularTitle: string;
	districtPluralTitle: string;
	matchupSingularTitle: string;
	matchupPluralTitle: string;
}
interface TeamLeagueStore {
	useScheduleGroups: boolean;
	setUseScheduleGroups: (useScheduleGroups: boolean) => void;
	scheduleGroupUuid: string;
	setScheduleGroupUuid: (scheduleGroupUuid: string) => void;
	playerMoves: ApproveTransfers;
	setPlayerMoves: (playerMoves: ApproveTransfers) => void;
	labels: TeamLeagueLabels;
	setLabels: (labels: TeamLeagueLabels) => void;
}

export const useTeamLeagueStore = create<TeamLeagueStore>((set) => ({
	useScheduleGroups: false,
	setUseScheduleGroups: (useScheduleGroups: boolean) => set({ useScheduleGroups }),
	scheduleGroupUuid: '',
	setScheduleGroupUuid: (scheduleGroupUuid: string) => set({ scheduleGroupUuid }),
	playerMoves: ApproveTransfers.UNDEFINED,
	setPlayerMoves: (playerMoves: ApproveTransfers) => set(() => ({ playerMoves: playerMoves })),
	labels: {
		tieBreakerMatchTitle: '',
		tieBreakerMatchPluralTitle: '',
		districtSingularTitle: '',
		districtPluralTitle: '',
		matchupSingularTitle: '',
		matchupPluralTitle: ''
	},
	setLabels: (labels: TeamLeagueLabels) => set({ labels })
}));

export type TeamLeagueStoreType = ReturnType<typeof useTeamLeagueStore.getState>;
